app.controller(
    'DiffController', ['$scope', '$rootScope', '$stateParams', '$translate','$timeout', 'ChangeLogService','$sce', DiffController]
);

function DiffController($scope, $rootScope, $stateParams, $translate, $timeout, ChangeLogService, $sce) {
    var vm = this;

    initController();

    function initController() {
        load($stateParams.id, $stateParams.lang);
    }

    function load(id, lang) {
        ChangeLogService.GetChangeLogById(id, lang)
            .then(function (changelog) {

                var oldvalue = angular.fromJson(changelog.OldValue);
                var newvalue = angular.fromJson(changelog.NewValue);
                var keys = [];
                for (var k in oldvalue) keys.push(k);
                for (var k in newvalue) {
                    if ($.inArray(k, keys)==-1)
                        keys.push(k);
                }
                
                var changeDetails = [];
                for (var name in keys) {
                    var k = keys[name];
                    var item = {};

                    item["Name"] = k;
                    if (oldvalue[k] !== undefined)
                        item["OriginalValue"] = oldvalue[k];
                    else
                        item["OriginalValue"] = "";
                    if (newvalue[k] !== undefined)
                        item["NewValue"] = newvalue[k];
                    else
                        item["NewValue"] = "";
                    changeDetails.push(item);
                }

                //vm.ChangeDetails = angular.fromJson(changelog.Description);
                vm.ChangeDetails = changeDetails;
                
                $timeout(function () {
                    compareAll();
                }, 10, false);

            });
    }

    function parseDetail (details) {
        return $interpolate(details)($scope);

    }

    $scope.getHtml = function (htmlContent) {
        return $sce.trustAsHtml(htmlContent);
    };
}
